module.exports = __webpack_public_path__ + "static/media/ic_chevron-down-primary.e0a22794.svg";